
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog-post/2022/02/bring-website-back-from-the-dead",
      function () {
        return require("private-next-pages/blog-post/2022/02/bring-website-back-from-the-dead.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog-post/2022/02/bring-website-back-from-the-dead"])
      });
    }
  